import 'jquery';

export class Spinner {
    static get TAG() { return 'Unify.Spinner'; }
    static get CLASS_SPINNER() { return 'unify-spinner'; }
    static get CLASS_SPINNER_FALLBACK() { return 'unify-spinner--button-inline'; }
    static get CLASS_SPINNER_CIRCLE() { return 'unify-spinner__circle'; }
    static get CLASS_SPINNER_CIRCLEINVERSE() { return 'unify-spinner__circle--inverse'; }
    static get CLASS_SPINNER_APPENDED() { return 'unify-spinner-appended'; }
    static get CLASS_SPINNER_PREPENDED() { return 'unify-spinner-prepended'; }
    static get SVG_NS() { return 'http://www.w3.org/2000/svg'; }

    /**
     * Creates a unify spinner SVG element and returns it.
     *
     * This method does not require any external dependencies,
     * and can therefore be run before jQuery has been loaded, for example.
     * 
     * @param {object} options options object
     * @return {object} spinner element
     */
    create(options) {

        if (!options || !options.class) {
            console.error(Spinner.TAG + '.create - Missing entry "class" in options. Please specify a class.');
            return null;
        }

        var spinnerEl = document.createElementNS(Spinner.SVG_NS, 'svg');
        var circleEl = document.createElementNS(Spinner.SVG_NS, 'circle');
        var circleInverseEl = document.createElementNS(Spinner.SVG_NS, 'circle');

        if (spinnerEl.classList) {
            spinnerEl.classList.add(Spinner.CLASS_SPINNER);
            spinnerEl.classList.add(options.class);
            circleEl.classList.add(Spinner.CLASS_SPINNER_CIRCLE);
            circleInverseEl.classList.add(Spinner.CLASS_SPINNER_CIRCLEINVERSE);
        } else {
            /* Fix IE11 crash caused by SVG elements not having a classList */

            var spinnerElClass = spinnerEl.getAttribute('class');
            spinnerEl.setAttribute('class', (spinnerElClass ? spinnerElClass + ' ' : '') + options.class + ' ' + Spinner.CLASS_SPINNER);

            var circleElClass = circleEl.getAttribute('class');
            circleEl.setAttribute('class', (circleElClass ? circleElClass + ' ' : '') + Spinner.CLASS_SPINNER_CIRCLE);

            var circleInverseElClass = circleInverseEl.getAttribute('class');
            circleInverseEl.setAttribute('class', (circleInverseElClass ? circleInverseElClass + ' ' : '') +
                Spinner.CLASS_SPINNER_CIRCLEINVERSE);

        }

        /*add svg attributes*/
        spinnerEl.setAttributeNS(null, 'viewBox', '0 0 64 64');

        circleEl.setAttributeNS(null, 'stroke', '#000');
        circleEl.setAttributeNS(null, 'cx', '32');
        circleEl.setAttributeNS(null, 'cy', '32');
        circleEl.setAttributeNS(null, 'r', '24');

        circleEl.setAttributeNS(null, 'stroke', '#000');
        circleInverseEl.setAttributeNS(null, 'cx', '32');
        circleInverseEl.setAttributeNS(null, 'cy', '32');
        circleInverseEl.setAttributeNS(null, 'r', '24');

        /*append elements*/
        spinnerEl.appendChild(circleInverseEl);
        spinnerEl.appendChild(circleEl);

        return spinnerEl;
    }

    /**
     * Appends a new unify spinner inside the first selected element.
     *
     * A special class is also added to notify observers that the spinner was appended.
     *
     * Dependent on jQuery
     *
     * @param {string} selector a selector
     * @param {object} options options object
     * @return {object} element
     */
    append(selector, options = { class: Spinner.CLASS_SPINNER_FALLBACK }) {

        var $element = $(selector).first();
        if (!selector || $element.length < 1) {
            return null;
        }

        var spinner = this.create(options);
        /*Using jQuery instead of native classList because IE11 doesnt have classList on SVG elemets*/
        $(spinner).addClass(Spinner.CLASS_SPINNER_APPENDED);

        $element.append(spinner);

        return $element[0];
    }

    /**
     * Prepends a new unify spinner inside the first selected element.
     *
     * A special class is also added to notify observers that the spinner was prepended.
     *
     * Dependent on jQuery
     * 
     * @param {string} selector a selector
     * @param {object} options options object
     * @return {object} element
     */
    prepend(selector, options = { class: Spinner.CLASS_SPINNER_FALLBACK }) {

        var $element = $(selector).first();
        if (!selector || $element.length < 1) {
            return null;
        }

        var spinner = this.create(options);
        /*Using jQuery instead of native classList because IE11 doesnt have classList on SVG elemets*/
        $(spinner).addClass(Spinner.CLASS_SPINNER_PREPENDED);

        $element.prepend(spinner);

        return $element[0];
    }
    /**
     * Removes all unify spinners inside the first selected element.
     *
     * Dependent on jQuery
     * 
     * @param {string} selector a selector
     * @return {object} element
     */
    remove(selector) {

        var $element = $(selector).first();
        if (!selector || $element.length < 1) {
            return null;
        }

        $element.find(Spinner.CLASS_SPINNER + ',' + Spinner.CLASS_SPINNER_APPENDED + ',' + Spinner.CLASS_SPINNER_PREPENDED).remove();

        return $element[0];
    }
}
